// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

export enum DevicePermissionState {
  Pending = 'pending',
  Denied = 'denied',
  Confirmed = 'confirmed',
}
